import Alpine from "alpinejs";
import Swiper, { Thumbs } from "swiper";

Alpine.data("modelGallery", () => ({
    activeTab: "exterior",
    setActiveTab(tab) {
        this.activeTab = tab;
    },
}));

const exteriorSliderThumbs = new Swiper("#exteriorThumbs", {
    spaceBetween: 10,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
    modules: [Thumbs],
});

const exteriorSlider = new Swiper("#exterior", {
    autoHeight: true,
    spaceBetween: 10,
    grabCursor: true,
    thumbs: {
        swiper: exteriorSliderThumbs,
    },
    modules: [Thumbs],
});

const interiorSliderThumbs = new Swiper("#interiorThumbs", {
    spaceBetween: 10,
    slidesPerView: 8,
    freeMode: true,
    watchSlidesProgress: true,
    modules: [Thumbs],
});

const interiorSlider = new Swiper("#interior", {
    autoHeight: true,
    spaceBetween: 10,
    grabCursor: true,
    thumbs: {
        swiper: interiorSliderThumbs,
    },
    modules: [Thumbs],
});
